// Import models.
import TableHeaderCellData from './TableHeaderCellData';

interface TableDataParameters<TDataType, TTableHeaderCellData extends TableHeaderCellData<TDataType> = TableHeaderCellData<TDataType>> {
    headers: TTableHeaderCellData[];
    data: TDataType[];
    rowId: (data: TDataType) => string;
}

class TableData<TDataType, TTableHeaderCellData extends TableHeaderCellData<TDataType> = TableHeaderCellData<TDataType>> {
    public headers: TTableHeaderCellData[];
    public data: TDataType[];
    public rowId: (data: TDataType) => string;

    public constructor(params: TableDataParameters<TDataType, TTableHeaderCellData>) {
        this.headers = params.headers;
        this.data = params.data;
        this.rowId = params.rowId;
    }
}

export {
    TableDataParameters,
};

export default TableData;